import axios from 'axios'
import authHeader from '../security/auth.header'

const API_URL = process.env.VUE_APP_BASE_API_URL + '/api/v1/admin-common/branch-categories'

class BranchCategoryApi {
  getList() {
    return axios.get(API_URL, { headers: authHeader() })
  }

  getDetail(uuid) {
    return axios.get(API_URL + '/' + uuid, { headers: authHeader() })
  }

  update(uuid, request) {
    return axios.put(API_URL + '/' + uuid, request, { headers: authHeader() })
  }
}

export default new BranchCategoryApi()
